/**
 * Recursive func to detect spidified cluster
 * @param map Instance of Leaflet
 * @param el Layer cluster
 */
export default function resursiveCheckNoGroups(map, el) {
  // eslint-disable-next-line no-underscore-dangle
  if (el._childClusters.length === 0) {
    // eslint-disable-next-line no-underscore-dangle
    return el._zoom === map.getMaxZoom();
    // eslint-disable-next-line no-underscore-dangle, no-else-return
  } else if (el._childClusters.length <= 1) {
    // eslint-disable-next-line no-underscore-dangle
    if (el._childCount === el._childClusters[0]._childCount) {
      // eslint-disable-next-line no-underscore-dangle
      return resursiveCheckNoGroups(map, el._childClusters[0]);
    }
    return false;
  }
  return false;
}
